module.exports = __webpack_public_path__ + "static/media/Heaven_Main.942808f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Heaven_Main.jpg
// module id = 175
// module chunks = 0